import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { CustomElement } from '@antv/g';
export function createElement(descriptor) {
  var render = typeof descriptor === 'function' ? descriptor : descriptor.render;
  return /*#__PURE__*/function (_CustomElement) {
    _inherits(_class, _CustomElement);
    function _class() {
      _classCallCheck(this, _class);
      return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
    }
    _createClass(_class, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.draw();
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback() {
        this.draw();
      }
    }, {
      key: "draw",
      value: function draw() {
        render(this);
      }
    }]);
    return _class;
  }(CustomElement);
}